"use client";

import { type FC, useState } from "react";

import {
  type THeaderMenuVariantProps,
} from "@/ui/components/navigation/Header/Header.config";
import {
  HeaderMenuLinks,
} from "@/ui/components/navigation/Header/HeaderMenuLinks";
import {
  HeaderMenuToggle,
} from "@/ui/components/navigation/Header/HeaderMenuToggle";
import { Sheet, SheetClose } from "@/ui/components/overlay/Sheet";
import { cn } from "@/ui/lib/utils";
import { useTranslations } from "next-intl";
import { AnimatedHorizontalRule } from "../../layout";

export const HeaderMobileMenu: FC<THeaderMenuVariantProps> = ({ items }) => {
  const [ isMenuOpen, setIsMenuOpen ] = useState(false);
  const t = useTranslations("Components.Header.Customer");

  return (
    <div data-component="HeaderMobileMenu">
      <button
        type="button"
        aria-label="Toggle menu"
        aria-expanded={isMenuOpen}
        aria-haspopup="dialog"
        data-component="HeaderMobileMenuTrigger"
        className={cn("inline-flex items-center justify-center")}
        onClick={() => setIsMenuOpen((open) => !open)}
      >
        <HeaderMenuToggle open={isMenuOpen} />
      </button>
      <Sheet
        open={isMenuOpen}
        onOpenChange={setIsMenuOpen}
        title={t("title")}
        description={t("description")}
        hideDescription={true}
        side="right"
        close={(
          <SheetClose
            aria-label={t("close")}
            className="size-11 p-0 opacity-100"
          >
            <HeaderMenuToggle open />
          </SheetClose>
        )}
      >
        <HeaderMenuLinks
          items={items}
          variant="sheet"
          onNavigate={() => setIsMenuOpen(false)}
        />
        <AnimatedHorizontalRule illustration="chasingYarn" className="absolute bottom-0 left-0"/>
      </Sheet>
    </div>
  );
};

HeaderMobileMenu.displayName = "HeaderMobileMenu";
